import { IconProps } from './types';

export function PaintPot({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 25 24" {...props}>
      <path
        fill="currentColor"
        d="M10.205 21.582c-1 0-2.01-.68-3.36-2.02l-3.46-3.46c-2.94-2.94-2.64-4.07 0-6.72l5.57-5.58c1.97-1.97 3.6-3.12 6.72 0l3.46 3.46c2.81 2.81 2.13 4.59 0 6.72l-5.57 5.57c-1.35 1.35-2.35 2.03-3.36 2.03Zm-5.76-6.55 3.46 3.46c2.12 2.12 2.47 2.13 4.6 0l5.57-5.57c1.67-1.67 2.1-2.5 0-4.6l-3.46-3.46c-2.19-2.19-2.85-1.74-4.6 0l-5.57 5.57c-2.12 2.13-2.3 2.3 0 4.6ZM20.285 21.458c-1.14 0-2.04-.44-2.48-1.21-.44-.77-.35-1.77.24-2.75l.66-1.09c.39-.64.96-1.01 1.58-1.01.62 0 1.2.37 1.58 1.01l.66 1.09c.59.98.67 1.98.24 2.75-.43.77-1.35 1.21-2.48 1.21Zm0-4.56c-.05 0-.17.08-.3.28l-.66 1.09c-.3.5-.38.95-.22 1.24.16.29.59.45 1.17.45s1.01-.16 1.17-.45c.16-.29.08-.73-.22-1.24l-.66-1.09c-.11-.21-.23-.28-.28-.28Z"
      />
      <path
        fill="currentColor"
        d="M2.145 12.99a.747.747 0 0 1-.19-1.47 34.127 34.127 0 0 1 17.38-.13l.5.13a.75.75 0 0 1-.37 1.45l-.5-.13a32.472 32.472 0 0 0-16.61.13c-.08.02-.15.02-.21.02Z"
      />
    </svg>
  );
}
